import dayjs from 'dayjs';
import useChartColors from './colors';
const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const useOptions = (roundingDecimals = 2) => {
  const { colors } = useChartColors();
  return {
    title: {
      text: '',
    },
    credits: {
      enabled: false,
    },
    yAxis: {
      labels: {
        formatter: function () {
          return (this.value > 0 ? ' + ' : '') + this.value + '%';
        },
      },
      plotLines: [
        {
          value: 0,
          width: 2,
          color: 'silver',
        },
      ],
    },
    colors,
    plotOptions: {
      series: {
        compare: 'percent',
        showInNavigator: true,
        turboThreshold: 4000,
      },
    },
    tooltip: {
      pointFormatter: function () {
        const defaults = ['price_return', 'close'];
        const plus = this.change > 0 ? '+' : '';
        const metricName = (this.series?.options?.metric || '').replaceAll('_', ' ');
        const metric = !defaults.includes(this.series?.options?.metric) ? `(${metricName})` : '';

        const value = Number(this.y).toFixed(roundingDecimals);
        const change = plus + Number(this.change).toFixed(roundingDecimals);

        return `<b>${this.series.name} ${metric}: ${value}</b> (${change}%)`;
      },
      valueDecimals: 2,
      split: true,
    },
    scrollbar: {
      barBackgroundColor: '#F1F2F2',
      barBorderRadius: 0,
      barBorderWidth: 0,
      buttonBackgroundColor: '#F1F2F2',
      buttonBorderWidth: 0,
      buttonBorderRadius: 0,
      trackBackgroundColor: 'none',
      trackBorderWidth: 1,
      trackBorderRadius: 0,
      trackBorderColor: 'slategrey',
      height: 12,
      liveRedraw: false,
    },
    time: {
      dayjs,
      timezone,
    },

    exporting: {
      menuItemDefinitions: {
        // Custom definition
        fullscreen: {
          onclick: () => console.log('Done'),
          text: 'Show fullscreen',
        },
      },
      buttons: {
        contextButton: {
          menuItems: [
            'viewFullscreen',
            'printChart',
            'separator',
            'downloadPNG',
            'downloadJPEG',
            'downloadPDF',
            'downloadSVG',
            'separator',
            'downloadCSV',
          ],
          // y: window.innerWidth < 768 ? 0 : -40,
        },
      },
    },
    chart: {
      type: 'line',
      spacingTop: 15,
      style: {
        fontFamily: '"Whitney Tabular A", "Whitney Tabular B", sans-serif',
      },
    },

    rangeSelector: {
      height: window.innerWidth < 490 ? 70 : 85,
      buttonTheme: {
        // styles for the buttons
        stroke: 'none',
        'stroke-width': 0,
        r: 0,
        width: 35,
        style: {
          color: '#212421',
          fontWeight: 'bold',
          textTransform: 'uppercase',
        },
      },
      inputStyle: {
        color: '#212421',
        fontWeight: 'bold',
        r: 0,
      },
      labelStyle: {
        color: '#727a7d',
        textTransform: 'uppercase',
      },

      inputBoxBorderColor: 'white',
      inputBoxBorderWidth: 0,
      inputBoxWidth: 120,
      inputBoxHeight: 18,
      inputPosition: {
        align: window.innerWidth < 490 ? 'left' : 'right',
        x: 0,
      },
      buttonPosition: {
        align: 'left',
        x: -3,
      },

      // selected: 5,
      inputEnabled: true,
    },
  };
};

export default useOptions;
